import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"

//region Types

export type WorkDomainWorkspaceDocument = RxDocument<WorkDomainWorkspace>
export type WorkDomainWorkspaceCollection = RxCollection<WorkDomainWorkspace>

//endregion

/**
 * Schema for work domain collections
 */
export const workDomainWorkspaceSchema: RxJsonSchema<WorkDomainWorkspace> = {
  title: "Work domain workspace schema",
  description: "Collection of all work domains for a specific workspace",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    designation: { type: "string", maxLength: 128 },
    allows_regular_adhoc: { type: "boolean" },
    allows_corrective_adhoc: { type: "boolean" },
    require_proof_of_presence: { type: "boolean" },
    shorthand_name: { type: "string", maxLength: 48, minLength: 1 },
  },
  required: ["id", "designation"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const workDomainWorkspaceCollectionCreator: RxCollectionCreator = {
  schema: workDomainWorkspaceSchema,
}
